import Types from '../../action/types';

const defaultState = {

    loading: false,
    tableData:[],
    // tableLoading:false,
};

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.TS_FILES_GET:
            return {
                ...state,
                tableData: action.tableData,
                // tableLoading:true
            }
        
        default:
            return state;
    }
}